import { combineReducers } from 'redux';
import auth from './auth';
import loading from './loading';
import transaction from './transaction';
import processing from './processing';
import customer from './customer';

export default combineReducers({
  auth,
  loading,
  transaction,
  processing,
  customer,
});
